import { ReactNode } from "react";
import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

interface LegalPageProps {
  title: string;
  updated: string;
  description: string;
  url: string;
  children: ReactNode;
}

/**
 * Impaginazione comune alle pagine legali (Privacy, Cookie).
 * Stile sobrio e leggibile, coerente col resto del sito.
 */
const LegalPage = ({ title, updated, description, url, children }: LegalPageProps) => (
  <Layout>
    <SEOHead title={`${title} | Studio Olistico ORIGINI`} description={description} url={url} />
    <div className="container mx-auto px-4 pt-28 pb-20 max-w-3xl">
      <p className="eyebrow">Informativa</p>
      <h1 className="mt-3 font-serif text-4xl md:text-6xl text-primary">{title}</h1>
      <p className="mt-3 text-sm text-muted-foreground">Ultimo aggiornamento: {updated}</p>
      <div className="mt-10 space-y-6 text-foreground/90 leading-relaxed [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:text-primary [&_h2]:mt-10 [&_h2]:mb-3 [&_a]:text-primary [&_a]:underline [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1">
        {children}
      </div>
    </div>
  </Layout>
);

export default LegalPage;
